<template>
    <div class="animated fadeIn">

        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-industry text-primary mr-2"></i>
                    Nueva Remesa
                </h4>
            </b-col>
        </b-row>

        <b-row class="my-2">
            <b-col>
                <b-card>
                    <b-row class="pt-2">
                        <b-col cols="12" md="6">
                            <b-form-group
                                label="<strong>Tipo *</strong>"
                                label-for="type">
                                <consignment-type-selector
                                    id="type"
                                    v-model="type"></consignment-type-selector>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="6">
                            <b-form-group
                                label="<strong>Sedes a Remesar *</strong>"
                                label-for="headquarters">
                                <headquarters-multiple-selector
                                    id="headquarters"
                                    v-model="headquarters"
                                    fromUser></headquarters-multiple-selector>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-group
                                label="<strong>Cuotas *</strong>"
                                label-for="periodicity">
                                <periodicity-months-multiple-selector
                                    id="periodicity"
                                    v-model="periodicity"></periodicity-months-multiple-selector>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="6">
                            <b-form-group
                                label="<strong>Métodos de Pago *</strong>"
                                label-for="paymentMethod">
                                <payment-method-multiple-selector
                                    id="paymentMethod"
                                    v-model="paymentMethods"></payment-method-multiple-selector>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>

                        <b-col cols="12" md="4">
                            <b-form-group
                                label="<strong>Fecha de Emisión *</strong>"
                                label-for="issueDate">
                                <month-and-year-selector
                                    id="issueDate"
                                    v-model="issueDate"></month-and-year-selector>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group
                                label="<strong>Fecha de Presentación *</strong>"
                                label-for="presentationDate">
                                <v-date-picker
                                    id="presentationDate"
                                    v-model="presentationDate"
                                    popoverDirection="top"
                                    class="p-0 date-picker-w-100 date-picker-custom-border"></v-date-picker>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group
                                label="<strong>Fecha de Cargo *</strong>"
                                label-for="chargeDate">
                                <v-date-picker
                                    id="chargeDate"
                                    v-model="chargeDate"
                                    popoverDirection="top"
                                    class="p-0 date-picker-w-100 date-picker-custom-border"></v-date-picker>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-group
                                label="<strong>Descripción *</strong>"
                                label-for="description">
                                <b-form-textarea
                                    v-model="description"
                                    placeholder="Descripción"
                                    :rows="3">
                                </b-form-textarea>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="6">
                            <b-form-group
                                label="<strong>Observaciones</strong>"
                                label-for="comment">
                                <b-form-textarea
                                    v-model="comment"
                                    placeholder="Observaciones"
                                    :rows="3">
                                </b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row v-if="mixinCheckPermission('CONSIGNMENT_NEW')" class="flex-row-reverse px-3 my-2">
                        <button
                            :disabled="!validConsignment"
                            class="btn btn-brand btn-primary btn-lg"
                            @click="saveConsignment()">
                            Guardar
                        </button>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import headquartersMultipleSelector from '@/components/headquarters/HeadquartersMultipleSelector';
    import consignmentTypeSelector from '@/components/consignments/ConsignmentTypeSelector';
    import periodicityMonthsMultipleSelector from '@/components/periodicity/PeriodicityMonthsMultipleSelector';
    import monthAndYearSelector from '@/components/MonthAndYearSelector';
    import paymentMethodMultipleSelector from '@/components/clients/members/PaymentMethodMultipleSelector';
    import {createConsignment} from '@/api/consignment-api';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: "AddConsignment",
        components: {
            'v-date-picker': DatePicker,
            headquartersMultipleSelector,
            consignmentTypeSelector,
            periodicityMonthsMultipleSelector,
            monthAndYearSelector,
            paymentMethodMultipleSelector
        },
        created() {
            this.$eventHub.$emit('captureMenu', this.topMenu);

            let date = new Date();
            date.setDate(1);
            this.issueDate = date;
            this.presentationDate = date;
            this.chargeDate = date;
        },
        data: function () {
            return {
                topMenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    }
                ],
                type: null,
                headquarters: [],
                description: null,
                comment: null,
                periodicity: [],
                paymentMethods: [],
                issueDate: null,
                presentationDate: null,
                chargeDate: null
            };
        },
        computed: {
            validConsignment() {
                return (
                    !!this.type
                    && !!this.description
                    && !!this.issueDate
                    && !!this.presentationDate
                    && !!this.chargeDate
                    && !!this.periodicity.length
                    && !!this.paymentMethods.length
                    && !!this.headquarters.length
                );
            },
            consignmentObject() {
                let date = new Date();
                this.issueDate.setHours(23);
                this.issueDate.setMinutes(59);
                this.issueDate.setSeconds(59);
                this.presentationDate.setHours(23);
                this.presentationDate.setMinutes(59);
                this.presentationDate.setSeconds(59);
                this.chargeDate.setHours(23);
                this.chargeDate.setMinutes(59);
                this.chargeDate.setSeconds(59);

                return {
                    type: this.type,
                    headquarters: this.headquarters.map(headquarter => (headquarter.uuid)),
                    description: this.description,
                    comment: this.comment,
                    periodicitiesMonths: this.periodicity,
                    paymentMethods: this.paymentMethods,
                    issueDate: this.issueDate,
                    presentationDate: this.presentationDate,
                    chargeDate: this.chargeDate
                }
            },
        },
        methods: {
            async saveConsignment() {
                if (this.validConsignment) {
                    this.$_loadingMixin_showLoading();
                    await createConsignment(this.consignmentObject)
                        .then(() => {
                            this.$_notificationMixin_success(
                                'Operación completada',
                                'Las remesas se han creado con éxito'
                            );
                            this.$router.push({path: '/accounting/consignments/list'});
                        })
                        .catch(() => {
                            this.$_notificationMixin_error(
                                'Operación no completada',
                                'Se ha producido un error'
                            );
                        });
                    this.$_loadingMixin_hideLoading();
                } else {
                    this.$_notificationMixin_error(
                        'Error en el formulario',
                        'Revise los campos'
                    );
                }
            }
        },
        watch: {
            issueDate: function () {
                if (this.issueDate) {
                    this.presentationDate = this.issueDate;
                    this.chargeDate = this.issueDate;
                }
            }
        }
    }
</script>

<style scoped>

</style>